import React, { useState, useEffect } from "react";
import { Input, Pagination, Button, Image, Radio, message } from "antd";
import {
  getRegisterApproved,
  addProduct,
  hideProduct,
  userProductIds,
  getProductList,
  removeProductList,
  updateMaterial,
} from "../../api/register";
import Tags from "./tags";
import styles from "./index.module.css";
import { SearchOutlined, LoadingOutlined } from "@ant-design/icons";
import { fileUrl } from "../../components/config";
import ProductDetail from "./productDetail";
import UserInfoStore from "../../store/userInfoStore";
import Header from "../../components/header/header";

const IndexApp = (props) => {
  const userInfo = UserInfoStore.getUserInfo();
  const [listData, setlistData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageTotal, setPageTotal] = useState(0);
  const [productDetail, setProductDetail] = useState(null);
  //search
  const [searchProductName, setSearchProductName] = useState("");
  const [copyrightsNames, setCopyrightsNames] = useState("");

  const [searchProductCatName, setSearchProductCatName] = useState("");
  const [ids, setIds] = useState([]);
  const [isFalg, setIsFalg] = useState(0);

  useEffect(() => {
    if (isFalg === 0) {
      setlistData([]);
      getRegisterApproved({
        size: 100,
        page,
        productName: searchProductName,
        copyrightsNames,
        tags: searchProductCatName === "" ? "" : searchProductCatName,
        order: "createTime",
        sort: "desc",
        hideFlag: 0,
      }).then((res) => {
        setlistData(res.list);
        setPageTotal(res.total);
      });
      userProductIds({}).then((res) => {
        setIds(res.result);
      });
    } else {
      setlistData([]);
      getProductList({
        page: page,
        size: 100,
        productName: searchProductName,
        copyrightsNames,
        tags: searchProductCatName === "" ? "" : searchProductCatName,
        order: "createTime",
        sort: "desc",
      }).then((res) => {
        setlistData(res.list);
        setPageTotal(res.total);
        setIsFalg(1);
      });
    }
  }, [page]);
  const search = (obj) => {
    const tags = obj?.searchProductCatName ?? searchProductCatName;
    if (isFalg === 0) {
      setlistData([]);
      getRegisterApproved({
        size: 100,
        page,
        productName: searchProductName,
        copyrightsNames,
        tags: tags === "" ? "" : tags,
        order: "createTime",
        sort: "desc",
        hideFlag: 0,
      }).then((res) => {
        setlistData(res.list);
        setPageTotal(res.total);
      });
      userProductIds({}).then((res) => {
        setIds(res.result);
      });
    } else {
      setlistData([]);
      getProductList({
        page: page,
        size: 100,
        productName: searchProductName,
        copyrightsNames,
        tags: tags === "" ? "" : tags,
        order: "createTime",
        sort: "desc",
      }).then((res) => {
        setlistData(res.list);
        setPageTotal(res.total);
        setIsFalg(1);
      });
    }
  };

  //admin隐藏作品，普通用户作品收藏
  const hidePro = (id) => {
       hideProduct({
        registerId: id,
        hideFlag: 1,
      }).then((res) => {
        getAllProductList();
      });
  }
  const addPro = (id) => {
      //收藏作品
      if (isFalg === 0) {
        addProduct({
          registerId: id,
        }).then((res) => {
          message.success(res.msg);
          let list = [];
          list.push(id);
          setIds(ids.concat(list));
        });
      } else {
        //取消收藏
        removeProductList({
          registerId: id,
        }).then((res) => {
          getProductList({
            page: page,
            size: 100,
            tags: searchProductCatName === "全部" ? "" : searchProductCatName,
            order: "createTime",
            sort: "desc",
          }).then((res) => {
            setlistData(res.list);
            setPageTotal(res.total);
            setIsFalg(1);
          });
        });
      
    }
  };

  //选为素材/移除素材
  const addMaterial = (id, isMaterial) => {
    //选为素材
    if (isMaterial === 0) {
      updateMaterial({
        registerId: id,
        isMaterial: 1,
      }).then((res) => {
        message.success(res.msg);
        collectProduct();
      });
    } else {
      //移除素材
      updateMaterial({
        registerId: id,
        isMaterial: 0,
      }).then((res) => {
        message.success(res.msg);
        collectProduct();
      });
    }
  };
  //全部列表
  const getAllProductList = () => {
    setIsFalg(0);
    setPage(1);
    setSearchProductName("");
    setCopyrightsNames("");
    setSearchProductCatName("");
    setlistData([]);
    getRegisterApproved({
      size: 100,
      page,
      productName: "",
      tags: "",
      order: "createTime",
      sort: "desc",
      copyrightsNames: "",
      hideFlag: 0,
    }).then((res) => {
      setlistData(res.list);
      setPageTotal(res.total);
    });
    userProductIds({}).then((res) => {
      setIds(res.result);
    });
  };

  //收藏列表
  const collectProduct = () => {
    setIsFalg(1);
    setPage(1);
    setSearchProductName("");

    setCopyrightsNames("");
    setSearchProductCatName("");
    setlistData([]);
    getProductList({
      page: page,
      size: 100,
      productName: "",
      tags: "",
      copyrightsNames: "",
      order: "createTime",
      sort: "desc",
    }).then((res) => {
      setlistData(res.list);
      setPageTotal(res.total);
    });
  };

  return (
    <div className="wrap">
      <div className={styles.listWrap}>
        <div className={styles.label}>
            <Radio.Group className={styles.radioBtn}>
              <Radio.Button onClick={() => getAllProductList()}>
                全部
              </Radio.Button>
              <Radio.Button value="default" onClick={() => collectProduct()}>
                精品
              </Radio.Button>
            </Radio.Group>
          <div className={styles.searchName}>
            <div className={styles.searchLabel}>著作权人：</div>
            <Input
              placeholder="请输入著作权人"
              size="middle"
              style={{
                width: 235,
                height: 32,
                border: "1px solid #1890ff",
                borderRadius: "6px",
              }}
              onChange={(e) => setCopyrightsNames(e.target.value)}
              value={copyrightsNames}
            />

            <div className={styles.searchLabel}>作品查询：</div>
            <Input
              placeholder="请输入作品名称"
              size="middle"
              style={{
                width: 235,
                height: 32,
                border: "1px solid #1890ff",
                borderRadius: "6px",
              }}
              onChange={(e) => setSearchProductName(e.target.value)}
              value={searchProductName}
            />
            <Button
              type="primary"
              size="middle"
              onClick={search}
              style={{
                display: "flex",
                height: 32,
                alignItems: "center",
                marginLeft: 10,
                borderRadius: "6px",
              }}
            >
              <SearchOutlined />
              搜索
            </Button>
          </div>
        </div>
        <Tags
          searchProductCatName={searchProductCatName}
          setSearchProductCatNameFun={(val) => {
            setSearchProductCatName(val);
            search({ searchProductCatName: val });
          }}
          setPage={() => setPage(1)}
        />
        <ul className={styles.content}>
          {listData.map((item, index) => {
            return (
              <li key={item.registerId}>
                <div onClick={() => setProductDetail(item)}>
                  {item.productImage &&
                  JSON.parse(item.productImage).length > 0 ? (
                    <Image
                      src={fileUrl + JSON.parse(item.productImage)[0].targetUrl}
                      loading="lazy"
                      preview={false}
                    />
                  ) : (
                    <Image
                      src="https://cdn.gzbqdj.com/register/725221101213207383/showImage/bee8453c15322ac4f4e3987118d98236.jpg"
                      preview={false}
                    />
                  )}
                  <div className={styles.textWrap}>
                    <p style={{ color: "#ff8a00", fontWeight: "bold" }}>
                      {item.productName}
                    </p>
                    <p style={{ fontSize: 14, paddingTop: 5 }}>
                      著作权人：{item.copyrightsNames}
                    </p>
                    <p style={{ fontSize: 14, paddingTop: 5 }}>
                      类别：{item.productCatName}
                    </p>
                  </div>
                </div>
                <div style={{ marginLeft: 10, marginBottom: 5 }}>
                 {userInfo.isManageUser && <Button
                      danger
                      shape="round"
                      size="small"
                      onClick={() => addPro(item.registerId)}
                    >
                      隐藏作品
                    </Button>
                    }
                    <span>
                      <Button
                        danger
                        shape="round"
                        size="small"
                        onClick={() => hidePro(item.registerId)}
                        style={{ marginRight: 10 }}
                      >
                        隐藏作品
                      </Button>
                      <Button
                        danger
                        shape="round"
                        size="small"
                        onClick={() => addPro(item.registerId)}
                        disabled={
                          isFalg === 0 && ids.includes(item.registerId)
                            ? true
                            : false
                        }
                      >
                        {isFalg === 1 ? "取消收藏" : "收藏作品"}
                        </Button>
                      {isFalg === 1 ? (
                        <Button
                          type="primary"
                          shape="round"
                          size="small"
                          onClick={() =>
                            addMaterial(item.registerId, item.isMaterial)
                          }
                          style={{ marginLeft: 10 }}
                        >
                          {item.isMaterial == 0 ? "选为素材" : "取消素材"}
                        </Button>
                      ) : null}
                    </span>
                 
                </div>
              </li>
            );
          })}
        </ul>
        <Pagination
          current={page}
          total={pageTotal}
          showSizeChanger={false}
          pageSize={50}
          onChange={(val) => {
            setPage(val);
            window.scrollTo({ top: 0 });
          }}
          style={{ textAlign: "right", padding: 20 }}
        />
        {productDetail && (
          <ProductDetail
            productDetail={productDetail}
            onCancel={() => setProductDetail(null)}
          />
        )}
      </div>
    </div>
  );
};
export default IndexApp;
